import { render, staticRenderFns } from "./McIcon.vue?vue&type=template&id=94636e1e&scoped=true"
import script from "./McIcon.vue?vue&type=script&lang=js"
export * from "./McIcon.vue?vue&type=script&lang=js"
import style0 from "./McIcon.vue?vue&type=style&index=0&id=94636e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94636e1e",
  null
  
)

export default component.exports